/**
 * * Модель запроса на подписку к очередностям пользователей
 */
export default class SubscribeToOrderTaskListRequestModel {
  /**
   * * Список id пользователей к очередностям которых нужно подписаться
   */
  UserIds!: Array<number>;
  constructor(obj?: Partial<SubscribeToOrderTaskListRequestModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
